<template>
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        Coins
        <small>You can add coins to users here</small>
      </h1>
    </section>

    <!-- Main content -->
    <section class="content">
      <div class="row">
        <div class="col-md-4">
          <!-- Default box -->
          <div class="box box-info">
            <div class="box-header with-border">
              <h3 class="box-title">Coin form</h3>
            </div>
            <div class="box-body">
              <div>
                <form class="form-horizontal">
                  <div class="form-group">
                    <label for="type" class="col-sm-2 control-label">Pretraga po:</label>
                    <div class="col-sm-10">
                      <select v-model="type" id="type" class="form-control">
                        <option value="nickname" selected>Nickname</option>
                        <option value="email">Email</option>
                        <option value="id">ID</option>
                        <option value="firstname">Ime</option>
                        <option value="lastname">Prezime</option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="term" class="col-sm-2 control-label">Traži</label>
                    <div class="col-sm-10">
                      <input autocomplete="off" v-model="term" @keyup="searchUser()" type="text" id="term" placeholder="Traži" class="form-control">
                      <div class="search-results-list">
                        <ul class="list-group">
                          <li style="cursor:pointer;" v-for="user in userList" @click="pickUser(user)" class="list-group-item">{{ decodeURI(user.nickname) }}</li>
                        </ul>
                        <small v-if="userList.length > 0 && selected_user == 0">Klikni na rezultat da odabereš igrača.</small>
                        <p v-if="userList.length == 0 && term.length > 0">Nije pronađen igrač.</p>
                      </div>
                    </div>
                  </div>
                  <div v-if="selected_user > 0">
                    <div class="jumbotron">
                      <p>Nick: {{ decodeURI(userInfo.nickname) }}</p>
                      <p>{{ userInfo.email }} {{ userInfo.firstname }} {{ userInfo.lastname }}</p>
                      <p>Coins: {{ userInfo.coins }}</p>
                      <p>ID: {{ userInfo.id }}</p>
                      <p></p>
                    </div>
                    <div class="form-group">
                      <label for="reason" class="col-sm-2 control-label">Razlog</label>
                      <div class="col-sm-10">
                        <textarea v-model="reason" id="reason" class="form-control" rows="2"></textarea>
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="reason" class="col-sm-4 control-label">Broj zlatnika</label>
                      <div class="col-sm-8">
                        <input type="number" v-model="coins_number" id="coins_number" class="form-control" />
                      </div>
                    </div>
                    <div class="box-footer">
                      <div>
                        <p class="text-danger text-right">{{ msg }}</p>
                        <button :disabled="coins_number == 0" @click="addCoins()" type="button" class="btn btn-info pull-right">
                          Add Coins
                        </button>
                      </div>
                    </div> <!---->
                  </div>

                </form>
              </div>
            </div>

          </div>

        </div>
        <div class="col-md-8">
          <table class="table table-condensed table-striped">
            <thead>
            <tr>
              <th>Nick</th>
              <th>Reason</th>
              <th>Coins</th>
              <th>From</th>
              <th>Date</th>
            </tr>
            </thead>
            <tbody v-if="transactions.length > 0">

              <tr v-for="transaction in transactions">
                <td>{{ decodeURI(transaction.nickname) }}</td>
                <!--<td>{{ transaction.user_id }}</td>-->
                <td>{{ decodeURI(transaction.reason) }}</td>
                <td>{{ transaction.coins_number }}</td>
                <td>{{ transaction.from_admin }}</td>
                <td>{{ transaction.date }}</td>
              </tr>

            </tbody>
            <tbody v-else>
            <div class="ui hidden divider"></div>
            <h3>
              List is empty
            </h3>
            <div class="ui hidden divider"></div>
            </tbody>
          </table>
        </div>
      </div>

    </section>
    <!-- /.content -->
  </div>
</template>

<script>
  export default {
    name: 'Coins',
    data: function () {
      return {
        transactions: [],
        userList: [],
        userInfo: {},
        form: new Form({}),
        term: '',
        type: 'nickname',
        selected_user: 0,
        coins_number: 0,
        reason: '',
        msg: ''
      }
    },
    created: function () {
      if (Number(this.$store.state.role) < 30) {
        this.$router.push('/dashboard')
      }
    },
    mounted: function () {
      var self = this
      $(function () {
        $('#datetimepicker').datetimepicker({
          locale: 'sr'
        })
        $(document).on('dp.change', '#datetimepicker', function (e) {
          self.date_to = e.date.utc().format()
        })
      })
      this.getTransactions()
    },
    methods: {
      getTransactions () {
        var self = this
        let data = {
          token_header: localStorage.getItem('token_header'),
          token_log: localStorage.getItem('token_log')
        }
        this.form.post(baseUrl + 'Admin/getLatestTransactions', data).then(function (result) {
          if (result.status === 1) {
            self.transactions = result.transactions
          }
        }, function (reason) {
        })
      },
      searchUser () {
        var self = this
        this.userList = []
        var searchTerm = this.term
        if (this.type === 'nickname') {
          searchTerm = encodeURI(this.term)
        }
        let data = {
          term: searchTerm,
          by: this.type,
          token_header: localStorage.getItem('token_header'),
          token_log: localStorage.getItem('token_log')
        }
        if (this.term.length > 2 || this.type === 'id') {
          this.form.post(baseUrl + 'Admin/searchUser', data).then(function (result) {
            if (result.status === 1) {
              self.userList = result.list
            }
          }, function (reason) {
          })
        }
      },
      pickUser: function (user) {
        this.userInfo = user
        this.selected_user = Number(user.id)
        this.userList = []
        this.term = ''
      },
      addCoins: function () {
        var self = this
        let data = {
          token_header: localStorage.getItem('token_header'),
          token_log: localStorage.getItem('token_log'),
          user_id: this.selected_user,
          from_admin: localStorage.getItem('user_id'),
          reason: this.reason,
          coins_number: this.coins_number
        }
        this.form.post(baseUrl + 'Admin/addCoins', data).then(function (result) {
          self.msg = result.msg
          if (Number(result.status) === 1) {
            window.location.reload()
          }
        }, function (reason) {
            // rejection
          console.log('Rejected', reason)
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Index.vue?d67a17fe